// @ts-nocheck
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LOGO from "../assets/images/newLogo.png";
import APPNAME from "../assets/images/appname.png";
import { Eye, EyeOff } from "lucide-react";
import { BASE_URL } from "../Constants/BaseUrl";

const ChangePassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const { email, isApp } = location.state || {};

  console.log("email: ", email);
  console.log("isApp?: ", isApp);

  const handleChangePassword = async () => {
    if (password.length < 6) {
      toast.error("Password must be at least 6 characters long");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    setLoading(true);

    try {
      const data = new FormData();
      data.append("email", email);
      data.append("secretKey", "updateMyPasswordPlease!!!");
      data.append("password", password);

      const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${BASE_URL}user/c-p`,
        data,
      };

      const response = await axios.request(config);

      console.log("Response:", JSON.stringify(response.data, null, 2));

      if (response.data?.success) {
        toast.success("Password changed successfully!");
        if (!isApp) {
          navigate("/login");
        } else {
          navigate(-1);
        }
      } else {
        toast.error(response.data?.message || "Failed to change password.");
      }
    } catch (error) {
      console.error("Error:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Failed to change password. Please try again.";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prev) => !prev);
  };

  return (
    <div className="h-screen bg-[#121212] flex items-center justify-center p-4">
      <ToastContainer />
      <div className="w-full max-w-md bg-[#1e1e1e] rounded-lg shadow-lg p-6 flex flex-col items-center">
        {/* Logo and App Name */}
        <img src={LOGO} alt="Logo" className="h-40 w-40 object-contain mb-4" />
        <img
          src={APPNAME}
          alt="App Name"
          className="h-16  object-contain mb-6"
        />

        {/* Title */}
        <p className="text-2xl font-bold text-white uppercase mb-2">
          Reset Your Password
        </p>
        <p className="text-gray-300 text-center mb-4">
          Enter your new password
        </p>

        {/* Password Input */}
        <div className="relative w-full mb-2">
          {" "}
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Enter Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-3 rounded-md bg-[#2a2a2a] text-white placeholder-gray-400 border border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 pr-10" // Changed: Added pr-10 for icon space
          />
          <button
            type="button"
            onClick={togglePasswordVisibility}
            className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-200"
          >
            {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}{" "}
          </button>
        </div>

        {/* Confirm Password Input */}
        <div className="relative w-full mb-4">
          {" "}
          <input
            type={showConfirmPassword ? "text" : "password"}
            placeholder="Re-enter Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="w-full px-4 py-3 rounded-md bg-[#2a2a2a] text-white placeholder-gray-400 border border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 pr-10" // Changed: Added pr-10 for icon space
          />
          <button
            type="button"
            onClick={toggleConfirmPasswordVisibility}
            className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-200"
          >
            {showConfirmPassword ? <EyeOff size={20} /> : <Eye size={20} />}{" "}
          </button>
        </div>

        {/* Save Password Button */}
        <button
          onClick={handleChangePassword}
          disabled={loading}
          className={`w-full py-2 bg-red-600 text-white rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-600 ${
            loading ? "opacity-50 cursor-not-allowed" : ""
          }`}
        >
          {loading ? "Saving..." : "Save Password"}
        </button>
      </div>
    </div>
  );
};

export default ChangePassword;
